import type { EditorSection, FieldSpec } from './types';

const P001 = 'CstmrCdtTrfInitn';
const P002 = 'CstmrPmtStsRpt';

export const PAIN001_FIELDS: FieldSpec[] = [
  {
    key: 'xmlns',
    xmlSelectors: ['Document@xmlns'],
    labelKey: 'try.fieldXmlns',
    defKey: 'try.defXmlns',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'msgId',
    xmlSelectors: [`${P001}/GrpHdr/MsgId`, `${P002}/OrgnlGrpInfAndSts/OrgnlMsgId`],
    labelKey: 'try.fieldMsgId',
    defKey: 'try.pain.defMsgId',
    kind: 'text',
  },
  {
    key: 'createdAt',
    xmlSelectors: [`${P001}/GrpHdr/CreDtTm`, `${P002}/GrpHdr/CreDtTm`],
    labelKey: 'try.fieldCreatedAt',
    defKey: 'try.defCreatedAt',
    kind: 'datetime',
  },
  {
    key: 'nbOfTxs',
    xmlSelectors: [`${P001}/GrpHdr/NbOfTxs`, `${P001}/PmtInf/NbOfTxs`],
    labelKey: 'try.fieldNbOfTxs',
    defKey: 'try.defNbOfTxs',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'ctrlSum',
    xmlSelectors: [`${P001}/GrpHdr/CtrlSum`, `${P001}/PmtInf/CtrlSum`],
    labelKey: 'try.pain.fieldCtrlSum',
    defKey: 'try.pain.defCtrlSum',
    kind: 'text',
    expertOnly: true,
    simpleAlias: 'amount',
  },
  {
    key: 'initgPtyName',
    xmlSelectors: [`${P001}/GrpHdr/InitgPty/Nm`],
    labelKey: 'try.pain.fieldInitgPty',
    defKey: 'try.pain.defInitgPty',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'pmtInfId',
    xmlSelectors: [`${P001}/PmtInf/PmtInfId`, `${P002}/OrgnlPmtInfAndSts/OrgnlPmtInfId`],
    labelKey: 'try.pain.fieldPmtInfId',
    defKey: 'try.pain.defPmtInfId',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'pmtMtd',
    xmlSelectors: [`${P001}/PmtInf/PmtMtd`],
    labelKey: 'try.pain.fieldPmtMtd',
    defKey: 'try.pain.defPmtMtd',
    kind: 'select',
    expertOnly: true,
    options: ['TRF', 'CHK'],
  },
  {
    key: 'svcLvl',
    xmlSelectors: [`${P001}/PmtInf/PmtTpInf/SvcLvl/Cd`],
    labelKey: 'try.fieldSvcLvl',
    defKey: 'try.defSvcLvl',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'chrgBr',
    xmlSelectors: [`${P001}/PmtInf/ChrgBr`],
    labelKey: 'try.fieldChrgBr',
    defKey: 'try.defChrgBr',
    kind: 'select',
    expertOnly: true,
    options: ['SLEV', 'DEBT', 'CRED', 'SHAR'],
  },
  {
    key: 'instructionId',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/PmtId/InstrId`, `${P002}/OrgnlPmtInfAndSts/TxInfAndSts/OrgnlInstrId`],
    labelKey: 'try.fieldInstructionId',
    defKey: 'try.defInstructionId',
    kind: 'text',
  },
  {
    key: 'endToEndId',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/PmtId/EndToEndId`, `${P002}/OrgnlPmtInfAndSts/TxInfAndSts/OrgnlEndToEndId`],
    labelKey: 'try.fieldEndToEndId',
    defKey: 'try.defEndToEndId',
    kind: 'text',
  },
  {
    key: 'amount',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/Amt/InstdAmt`],
    labelKey: 'try.fieldAmount',
    defKey: 'try.pain.defAmount',
    kind: 'text',
  },
  {
    key: 'currency',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/Amt/InstdAmt@Ccy`, `${P001}/PmtInf/DbtrAcct/Ccy`],
    labelKey: 'try.fieldCurrency',
    defKey: 'try.defCurrency',
    kind: 'text',
  },
  {
    key: 'executionDate',
    xmlSelectors: [`${P001}/PmtInf/ReqdExctnDt/Dt`],
    labelKey: 'try.pain.fieldExecutionDate',
    defKey: 'try.pain.defExecutionDate',
    kind: 'date',
  },
  {
    key: 'debtorName',
    xmlSelectors: [`${P001}/PmtInf/Dbtr/Nm`],
    labelKey: 'try.fieldDebtorName',
    defKey: 'try.defDebtorName',
    kind: 'text',
  },
  {
    key: 'debtorIban',
    xmlSelectors: [`${P001}/PmtInf/DbtrAcct/Id/IBAN`],
    labelKey: 'try.fieldDebtorIban',
    defKey: 'try.defDebtorIban',
    kind: 'text',
  },
  {
    key: 'debtorBic',
    xmlSelectors: [`${P001}/PmtInf/DbtrAgt/FinInstnId/BICFI`],
    labelKey: 'try.fieldDebtorBic',
    defKey: 'try.defDebtorBic',
    kind: 'text',
  },
  {
    key: 'creditorBic',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/CdtrAgt/FinInstnId/BICFI`],
    labelKey: 'try.fieldCreditorBic',
    defKey: 'try.defCreditorBic',
    kind: 'text',
  },
  {
    key: 'creditorName',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/Cdtr/Nm`],
    labelKey: 'try.fieldCreditorName',
    defKey: 'try.defCreditorName',
    kind: 'text',
  },
  {
    key: 'creditorIban',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/CdtrAcct/Id/IBAN`],
    labelKey: 'try.fieldCreditorIban',
    defKey: 'try.defCreditorIban',
    kind: 'text',
  },
  {
    key: 'remittance',
    xmlSelectors: [`${P001}/PmtInf/CdtTrfTxInf/RmtInf/Ustrd`],
    labelKey: 'try.fieldRemittance',
    defKey: 'try.defRemittance',
    kind: 'text',
  },
  {
    key: 'statusMsgId',
    xmlSelectors: [`${P002}/GrpHdr/MsgId`],
    labelKey: 'try.pain.fieldStatusMsgId',
    defKey: 'try.pain.defStatusMsgId',
    kind: 'text',
    expertOnly: true,
    simpleAlias: 'msgId',
  },
  {
    key: 'orgnlMsgNmId',
    xmlSelectors: [`${P002}/OrgnlGrpInfAndSts/OrgnlMsgNmId`],
    labelKey: 'try.fieldOrgnlMsgNmId',
    defKey: 'try.pain.defOrgnlMsgNmId',
    kind: 'text',
    expertOnly: true,
  },
  {
    key: 'outcome',
    xmlSelectors: [`${P002}/OrgnlGrpInfAndSts/GrpSts`, `${P002}/OrgnlPmtInfAndSts/TxInfAndSts/TxSts`],
    labelKey: 'try.pain.outcome',
    defKey: 'try.pain.outcomeDef',
    kind: 'select',
    options: ['ACTC', 'RJCT'],
  },
  {
    key: 'rejectReason',
    xmlSelectors: [`${P002}/OrgnlGrpInfAndSts/StsRsnInf/Rsn/Cd`],
    labelKey: 'try.reason',
    defKey: 'try.reasonDef',
    kind: 'select',
    options: ['AC01', 'AC03', 'AC04', 'AM04', 'AG01', 'AM02', 'DT01'],
  },
  {
    key: 'addtlInf',
    xmlSelectors: [`${P002}/OrgnlGrpInfAndSts/StsRsnInf/AddtlInf`],
    labelKey: 'try.fieldAddtlInf',
    defKey: 'try.defAddtlInf',
    kind: 'text',
    expertOnly: true,
  },
];

export const PAIN001_SIMPLE_SECTIONS: EditorSection[] = [
  { id: 'money', titleKey: 'try.sectionMoney', keys: ['amount', 'currency'], columns: 2 },
  {
    id: 'ids',
    titleKey: 'try.sectionIds',
    keys: ['endToEndId', 'instructionId', 'msgId'],
    columns: 2,
  },
  { id: 'debtor', titleKey: 'try.sectionDebtor', keys: ['debtorName', 'debtorIban', 'debtorBic'] },
  {
    id: 'creditor',
    titleKey: 'try.sectionCreditor',
    keys: ['creditorName', 'creditorIban', 'creditorBic'],
  },
  { id: 'remittance', titleKey: 'try.sectionRemittance', keys: ['remittance'] },
  { id: 'timing', titleKey: 'try.sectionTiming', keys: ['executionDate', 'createdAt'] },
];

export const PAIN001_EXPERT_SECTIONS: EditorSection[] = [
  { id: 'document', titleKey: 'try.sectionDocument', keys: ['xmlns'] },
  {
    id: 'grphdr',
    titleKey: 'try.sectionGrpHdr',
    keys: ['msgId', 'createdAt', 'nbOfTxs', 'ctrlSum', 'initgPtyName'],
    columns: 2,
  },
  {
    id: 'pmtinf',
    titleKey: 'try.pain.sectionPmtInf',
    keys: ['pmtInfId', 'pmtMtd', 'svcLvl', 'chrgBr', 'executionDate'],
    columns: 2,
  },
  {
    id: 'pmtid',
    titleKey: 'try.sectionPmtId',
    keys: ['instructionId', 'endToEndId'],
    columns: 2,
  },
  {
    id: 'tx',
    titleKey: 'try.sectionTxInf',
    keys: ['amount', 'currency'],
    columns: 2,
  },
  { id: 'debtor', titleKey: 'try.sectionDebtor', keys: ['debtorName', 'debtorIban', 'debtorBic'] },
  {
    id: 'creditor',
    titleKey: 'try.sectionCreditor',
    keys: ['creditorName', 'creditorIban', 'creditorBic'],
  },
  { id: 'remittance', titleKey: 'try.sectionRemittance', keys: ['remittance'] },
  {
    id: 'status',
    titleKey: 'try.pain.sectionStatus',
    keys: ['statusMsgId', 'orgnlMsgNmId', 'outcome', 'rejectReason', 'addtlInf'],
    columns: 2,
  },
];

export const PAIN001_SIMPLE_SYNC: Partial<Record<string, string[]>> = {
  amount: ['ctrlSum'],
};
